var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"78a4ca2c9f407d689d2d72c4bae6756dd45fc205"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-web@token-traxx"]={id:"78a4ca2c9f407d689d2d72c4bae6756dd45fc205"};
      